if (!customElements.get('two-column-product-data')) {
  customElements.define(
    'two-column-product-data',
    class TwoColumnProductData extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      sectionId = undefined;
      productUrl = undefined;

      connectedCallback() {
        this.sectionId = this.dataset.sectionId || this.getSectionId();
        this.productUrl = this.dataset.productUrl || window.location.pathname;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.handleVariantChange(event);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      getSectionId() {
        const sectionElement = this.closest('[id^="shopify-section-"]');
        if (sectionElement) {
          return sectionElement.id.replace('shopify-section-', '');
        }
        const elementId = this.id;
        if (elementId) {
          return elementId.replace('TwoColumnProductData-', '');
        }
        return null;
      }

      handleVariantChange(event) {
        if (!this.sectionId || !event.data?.variant) return;

        const variantId = event.data.variant.id;
        const currentUrl = this.productUrl || window.location.pathname;
        const fetchUrl = `${currentUrl}?variant=${variantId}&section_id=${this.sectionId}`;

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionWrapper = html.querySelector('.shopify-section');
            if (!sectionWrapper) return;
            
            const newSectionElement = sectionWrapper.querySelector('two-column-product-data');
            const newContent = newSectionElement 
              ? newSectionElement.querySelector('.two-column-product-data')
              : sectionWrapper.querySelector('.two-column-product-data');
            
            if (!this.classList.contains('section-' + this.sectionId + '-padding')) {
              this.classList.add('section-' + this.sectionId + '-padding');
            }
            
            const newStyleElement = sectionWrapper.querySelector('style');
            if (newStyleElement && newStyleElement.textContent.includes('section-' + this.sectionId + '-padding')) {
              const existingStyle = document.querySelector(`style[data-section-id="${this.sectionId}"]`);
              if (existingStyle) {
                existingStyle.textContent = newStyleElement.textContent;
              } else {
                const styleTag = document.createElement('style');
                styleTag.setAttribute('data-section-id', this.sectionId);
                styleTag.textContent = newStyleElement.textContent;
                document.head.appendChild(styleTag);
              }
            }
            
            if (newContent) {
              const openAccordions = this.getOpenAccordions();
              this.updateSectionContent(newContent);
              this.restoreAccordionState(openAccordions);
            }
          })
          .catch((error) => {
            console.error('Error updating two-column-product-data:', error);
          });
      }

      getOpenAccordions() {
        const openDetails = this.querySelectorAll('details[open]');
        return Array.from(openDetails).map((detail) => detail.id);
      }

      restoreAccordionState(openAccordionIds) {
        openAccordionIds.forEach((id) => {
          const detail = this.querySelector(`#${id}`);
          if (detail) {
            detail.open = true;
          }
        });
      }

      updateSectionContent(newContent) {
        const currentContent = this.querySelector('.two-column-product-data');
        
        if (currentContent && newContent) {
          if (window.HTMLUpdateUtility && window.HTMLUpdateUtility.viewTransition) {
            window.HTMLUpdateUtility.viewTransition(
              currentContent,
              newContent,
              [],
              []
            );
          } else {
            currentContent.innerHTML = newContent.innerHTML;
          }
        }
      }
    }
  );
}

